import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsPauseNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M3.125 1C2.504 1 2 1.504 2 2.125v11.75C2 14.496 2.504 15 3.125 15h2.75C6.496 15 7 14.496 7 13.875V2.125C7 1.504 6.496 1 5.875 1zm.125 12.75V2.25h2.5v11.5zM10.125 1C9.504 1 9 1.504 9 2.125v11.75C9 14.496 9.504 15 10.125 15h2.75c.621 0 1.125-.504 1.125-1.125V2.125C14 1.504 13.496 1 12.875 1zm.125 12.75V2.25h2.5v11.5z" />
      </g>
    </svg>
  )
);
SvgActionsPauseNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsPauseNormalXsmall;
